import { Organization } from './organization';
import { Rodeo } from './rodeo';
import { Account } from './account';

export class SearchOptions {
    searchText: string = null;
    organizations: Organization[] = [];
    eventTypes: string[] = [];
    
    fromDate: string = null;
    toDate: string = null;

    staffSearch: boolean;
    
    minAddedMoney: number = null;
    maxAddedMoney: number = null;

    showUpcoming: boolean;
    showOpen: boolean;

    rodeos: Rodeo[] = [];
    requestedById: number = null;
    status: string = null;

    contestants: Account[] = [];
}


// WEBPACK FOOTER //
// ./src/model/searchOptions.ts